import { Component, Inject, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RmsNavComponent } from '../rms-nav/rms-nav.component';
import { RmsPolicyPermissionsService } from './../../shared/core-rms/rms-policy-permissions.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class RmsHomeComponent {
  @ViewChild(RmsNavComponent) rmsNavComponent: RmsNavComponent;

  programItems: any = [];

  teamLeadershipPermissions = [
    'Reports:TeamLeadership:General',
    'Reports:TeamLeadership:Sensitive'
  ];

  constructor(
    @Inject('APP_PATH') public appPath: string,
    private _title: Title,
    private policyPermissionsService: RmsPolicyPermissionsService) {
      //window.localStorage.clear();  //Tentatively removed - we are now saving searches between sessions, so this has to go. If anything strange starts to break between sessions this is a possible culprit.
      this._title.setTitle("Home - RMS");
    }

  onInitializePrograms(event) {
    this.initializeProgramItems(event);

    let bpb = document.querySelector('[bypass-block]');
    if (bpb instanceof HTMLElement) {
      bpb.focus();
      bpb.blur();
    }
  }

  initializeProgramItems(tabs: any) {
    let responderUrl = "";
    if (this.policyPermissionsService.hasPermission("Responder:Search:Access")) {
      responderUrl = "/rms/responders/responder-search";
    }
    else if (this.policyPermissionsService.hasPermission("Credentialing:Access")) {
      responderUrl = "/rms/responders/credentialing";
    }
    else if (this.policyPermissionsService.hasPermission("Team:Search:Access")) {
      responderUrl = "/rms/responders/teams/team-search";
    }

    this.policyPermissionsService.loadEffectivePermissions(this.teamLeadershipPermissions, null)
      .then(() => {
        let reportsUrl = "/rms/reports/landing";
        if (this.policyPermissionsService.hasPermission("Reports:TeamLeadership:General") || this.policyPermissionsService.hasPermission("Reports:TeamLeadership:Sensitive")) {
          reportsUrl = "/rms/reports/dashboard-leadership";
        }
        
        let programItems = [
          { name: "Admin", url: "/rms/system-management/admin", iconClass: "glyphicon glyphicon-cog", accessible: this.hasAdminTab(tabs['admin']) },
          { name: "Finance", url: "/rms/finance", iconClass: "glyphicon glyphicon-usd", accessible: this.hasFinanceTab(tabs['finance']) },
          { name: "Responders", url: responderUrl, iconClass: "pi pi-user", accessible: this.hasResponderTab(tabs['responders']) },
          { name: "Events", url: "/rms/events/event-search", iconClass: "pi pi-calendar", accessible: this.hasEventsTab(tabs['events']) },
          { name: "Deployment", url: "/rms/deployment/roster-search", iconClass: "glyphicon glyphicon-map-marker", accessible: this.hasDeploymentsTab(tabs['deployment']) },
          { name: "PARS", url: "/rms/pars", iconClass: "glyphicon glyphicon-check", accessible: this.hasParsTab(tabs['responders']) },
          { name: "Travel", url: "/rms/travel/travel-roster-search", iconClass: "glyphicon glyphicon-plane", accessible: this.hasTravelTab(tabs['travel']) },
          { name: "Self Service", url: "/rms/responders/self-service", iconClass: "glyphicon glyphicon-list-alt", accessible: this.hasSelfServiceTab(tabs['self-service']) },
          { name: "Reports", url: reportsUrl, iconClass: "glyphicon glyphicon-file", accessible: this.hasReports(tabs['reports']) }
        ];
        this.programItems = programItems.filter(i => i.accessible);
      });
  }

  private hasAdminTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Admin:Access']);
  }

  private hasResponderTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Responder:Search:Access', 'Credentialing:Access', 'Team:Search:Access']);
  }

  private hasFinanceTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Finance:Access']);
  }

  private hasEventsTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Event:Search:Access']);
  }

  private hasDeploymentsTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Roster:Search:Access']);
  }

  private hasParsTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Pars:Access']);
  }

  private hasTravelTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Travel:TravelRoster:Search:Access']);
  }

  private hasSelfServiceTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['SelfService:Access']);
  }

  private hasReports(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Reports:Access']);
  }

  onMainContentClick() {
    let mc = document.querySelector('[main-content]');
    if (mc instanceof HTMLElement) {
      mc.focus();
      mc.blur();
    }
  }
}
